import React from 'react';
import { useTranslation } from 'react-i18next';
import DynamicCrudPage from '../../../components/DynamicCrudPage';
import { usePaymentPlanTemplates, useCompanies } from '../../../hooks';
import AddIcon from '@mui/icons-material/Add';

const PaymentPlanTemplatesPage = () => {
  const { t } = useTranslation();

  return (
    <DynamicCrudPage
      entityType="paymentPlanTemplates"
      hook={usePaymentPlanTemplates}
      additionalHooks={{
        companies: useCompanies,
      }}
      addButtonTextKey="table.actions.addPaymentPlanTemplate"
      addButtonIcon={<AddIcon />}
      entityTypeForDataTable="paymentPlanTemplate"
    />
  );
};

export default PaymentPlanTemplatesPage;
